window.addEventListener('pageshow', () => {
  var clear = () => {
    document.querySelectorAll('.action a').forEach(e => {
      e.href = '';
    });
    var e = null;
    e = document.querySelector('.trial-section');
    e.classList.remove('visible');
    document.querySelectorAll('.trial_box').forEach(e => {
      e.classList.remove('visible');
    });
    document.querySelectorAll('.stuff > *').forEach(e => {
      e.classList.remove('visible');
    });
  };
  var show = select => {
    var value = select.value;
    var options = select.options;
    var text = options[options.selectedIndex].text;
    var e = null;
    if (text) {
      document.querySelectorAll('.action a').forEach(e => {
        e.href = 'https://line.ipallets.jp/trialcalendar?school_name=' + text;
      });
    }
    document.querySelectorAll('.school-name').forEach(e => {
      e.innerHTML = text;
    });
    e = document.querySelector('.trial-section');
    e.classList.add('visible');
    document.querySelectorAll(`.trial_box.${value}`).forEach(e => {
      e.classList.add('visible');
    });
    if (value === 'online') {
      e = document.querySelector('.stuff .online');
    } else {
      e = document.querySelector('.stuff .not-online');
    }
    e.classList.add('visible');
  };
  var mount = search => {
    var param = new URLSearchParams(search);
    var school = param.get('school');
    if (!school) {
      return;
    }
    for (var o of select.options) {
      if (o.value === school) {
        o.selected = true;
        show(select);
        break;
      }
    }
  };
  clear();
  var select = document.querySelector('select[name=school]');
  select.addEventListener('change', e => {
    clear();
    if (e.target.value) {
      show(e.target);
    }
  });
  if (location.search) {
    mount(location.search);
  }
});
